import { render, staticRenderFns } from "./ClinicDashboardFooter.vue?vue&type=template&id=5e1ee89e&"
import script from "./ClinicDashboardFooter.vue?vue&type=script&lang=js&"
export * from "./ClinicDashboardFooter.vue?vue&type=script&lang=js&"
import style0 from "./ClinicDashboardFooter.vue?vue&type=style&index=0&id=5e1ee89e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports